import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import { dateCompare } from "jsFunctions/dateTimeFormat";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";

const PaymentRecordTable = ({ editSpentInfo, currentSpentInfo, type,currency }) => {
    return (

        type === 'current' ?
            <div className="info-table change-modal-table">

                <Table className="table-info">
                    <Thead>
                        <Tr>
                            <Th>Payment Mode</Th>
                            <Th>Amount</Th>
                            <Th>Bank Charge</Th>
                            <Th>Reference No</Th>
                            <Th>Date</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {editSpentInfo.map((item, index) => {
                            const payMod = allPaymentMode.find(opt=> opt.id === item.mod)
                            return (
                                <Tr>
                                    <Td className={`${item?.mod !== currentSpentInfo[index]?.mod ? 'data_compare_red' : ''}`}>{payMod?.value}</Td>
                                    <Td className={`${item?.amt !== currentSpentInfo[index]?.amt ? 'data_compare_red' : ''}`}>{currencySymbolByCode(currency || "INR")} {formatAmountIndianRupees(parseFloat(item?.amt || 0))}</Td>
                                    <Td className={`${item?.crg !== currentSpentInfo[index]?.crg ? 'data_compare_red' : ''}`}>{currencySymbolByCode(currency || "INR")} {formatAmountIndianRupees(item?.crg)}</Td>
                                    <Td className={`${item?.ref !== currentSpentInfo[index]?.ref ? 'data_compare_red' : ''}`}>{item?.ref}</Td>

                                    <Td className={`${!(dateTimeFormat(item?.pmtDt), dateTimeFormat(currentSpentInfo[index]?.pmtDt)) ? 'data_compare_red' : ''}`}>{dateTimeFormat(item?.pmtDt)}</Td>

                                </Tr>

                            );
                        })}
                    </Tbody>
                </Table>
            </div>
            :
            <div className="info-table change-modal-table">

                <Table size="md" className="table-info" w='100'>
                    <Thead>
                        <Tr>
                            <Th>Payment Mode</Th>
                            <Th>Amount</Th>
                            <Th>Bank Charge</Th>
                            <Th>Reference No</Th>
                            <Th>Date</Th>

                        </Tr>
                    </Thead>
                    <Tbody>
                        {currentSpentInfo?.map((item, index) => {
                            const payMod = allPaymentMode.find(opt=> opt.id === item.mod)

                            return (
                                <Tr>
                                    <Td className={`${item?.mod !== editSpentInfo[index]?.mod ? 'data_compare_green' : ''}`}>{payMod?.value}</Td>
                                    <Td className={`${item?.amt !== editSpentInfo[index]?.amt ? 'data_compare_green' : ''}`}>{currencySymbolByCode(currency || "INR")} {formatAmountIndianRupees(parseFloat(item?.amt || 0))}</Td>
                                    <Td className={`${item?.crg !== editSpentInfo[index]?.crg ? 'data_compare_green' : ''}`}>{currencySymbolByCode(currency || "INR")} {formatAmountIndianRupees(parseFloat(item?.crg || 0))}</Td>
                                    <Td className={`${item?.ref !== editSpentInfo[index]?.ref ? 'data_compare_green' : ''}`}>{item?.ref}</Td>

                                    <Td className={`${!dateCompare(dateTimeFormat(item?.pmtDt), dateTimeFormat(editSpentInfo[index]?.pmtDt)) ? 'data_compare_green' : ''}`}>{dateTimeFormat(item?.paymentDate)}</Td>

                                </Tr>

                            );
                        })}
                    </Tbody>
                </Table>
            </div>
    )


}

export default PaymentRecordTable;
